import { render } from "./myFooter.vue?vue&type=template&id=d1370fca&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"

import "./myFooter.vue?vue&type=style&index=0&id=d1370fca&lang=scss&scoped=true"
import "./myFooter.vue?vue&type=style&index=1&id=d1370fca&lang=css"

import exportComponent from "/chaopin/jpom/data/build/66617637594a40d3882f98d9518ea655/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1370fca"]])

export default __exports__